export default __webpack_public_path__ + "52801ae37f6c91373cbef1265f90df5d.png";